import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import FinancialStatementUpdateWillMount from "../../../Middleware/Middlewares/FinancialStatementUpdateWillMount";
import { FinancialStatementInterface } from "Casadesk/Entity/Entities/FinancialStatement/FinancialStatementInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import FinancialStatementStatusContainer from "../../../Entity/Entities/FinancialStatement/Status/FinancialStatementStatusContainer";
import ReadinessStatusContainer from "../../../Entity/Entities/FinancialStatement/ReadinessStatus/ReadinessStatusContainer";
import { StatementDataRenderer } from "../../Partials/Balance/StatementDataRenderer";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import {
  Card,
  Button,
  ButtonGroup,
  CircularProgress,
  FormControlLabel,
  Switch
} from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import CasedeskUrl from "../../../Url/Url";
import { SavingsCompanyDialog } from "../../Partials/Dialog/SavingsCompanyDialog";

class FinancialStatementUpdate extends Component {
  protected middlewares: MiddlewareInterface[] = [
    FinancialStatementUpdateWillMount
  ];

  protected financialStatement: FinancialStatementInterface;

  public state = {
    isAgencyStatement: false,
    financialStatementData: null,
    isSent: false,
    isFetchingStatement: true,
    isSaving: false,
    isCreateInvoicePopupOpen: false,
    isActivateInvoicingPopupOpen: false,
    previewTypeOfPdf: false,
    // TODO fix hardcoded values
    languageForPdf: this.props.app?.settings?.agency?.defaultLocale?.iso === "en-US" ? 1 : 2,
    isStatementOutdatedPopupOpen: false,
    financialStatements: [],
    expanded: 0,
    statementId: null,
    openSavingsDialog: false,
    savingsType: "withdrawal",
    entity: null,
    amountWithdrawal: 0,
  }

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    if (!this.props?.financialStatements?.requestsOutdated && nextProps?.financialStatements?.requestsOutdated) {
      this.initializePage(nextProps?.params?.id);
    }
  }

  public initializePage = (id: number) => {
    this.setState({
      isSaving: true,
      statementId: id,
    })
    this.props.dispatch({
      type: Constants.GLOBAL_FINANCIAL_STATEMENT_DATA_START,
      payload: {
        id: id
      },
      onSuccess: (financialStatements) => {
        if (!financialStatements.length) {
          return this.redirectBack();
        }

        const owner = this.props.app.companies.find(company => company.id === financialStatements?.[0]?.ownerId);
        const person = owner.persons.find(person => !!person.email);
        let languageForPdf = this.state.languageForPdf;
        // TODO fix hardcoded values
        if (person?.languageTypeId) {
          languageForPdf = person?.languageTypeId;
        } else if (owner.persons?.[0]?.languageTypeId) {
          languageForPdf = owner.persons?.[0]?.languageTypeId;
        }
        this.setState({
          isFetchingStatement: false,
          isAgencyStatement: financialStatements?.[0]?.ownerId === this.getAgency()?.id,
          languageForPdf: languageForPdf,
          financialStatements: financialStatements,
          expanded: financialStatements.length > 0 ? financialStatements.findIndex((statement) => +statement.id === +this.state.statementId) : 0,
          isSaving: false,
          entity: owner,
        });
      },
      onError: this.redirectBack
    })
  }

  public download = (chargeId: number): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_FINANCIAL_STATEMENT_DOWNLOAD_START,
        payload: {
          chargeId: chargeId,
          language: this.state.languageForPdf
        },
        onSuccess: url => {
          window.open(CasedeskUrl.getAttachment(url), "_blank");

          this.setState({
            isSaving: false,
            previewTypeOfPdf: false
          })
        },
        onError: () => {
          this.setState({
            isSaving: false,
            previewTypeOfPdf: false
          })
        }
      });
    })
  }

  public changeStatementStatusToDefinitive = (isPrintProcess: boolean) => {
    const financialStatement = this.state.financialStatements[this.state.financialStatements.length - 1];

    // Open immediately while still in the click handler's trusted context
    // Once the dispatch activates async code the event handler is out of the trusted context 
    // and the browser would block any pop-up
    const windowForPdf = isPrintProcess ? window.open("", "_blank") : null;

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_FINANCIAL_STATEMENT_LOCK_START,
        payload: {
          financialStatementId: financialStatement?.id,
          actualPayoutChargeId: financialStatement?.data?.payoutSection?.actualPayoutCharge?.id,
          chargesForSettleIds: financialStatement?.data?.payoutSection?.settlementCharges?.map(charge => charge?.id),
          language: this.state.languageForPdf,
          updatedAt: financialStatement?.updatedAt
        },
        onSuccess: (financialStatementData) => {
          const updatedStatements = this.state?.financialStatements.map(statement => {
            if (statement.id === financialStatementData?.financialStatement?.id) {
              return financialStatementData?.financialStatement
            } else {
              return statement
            }
          });
          this.setState({
            financialStatements: updatedStatements
          }, () => {

            if (isPrintProcess && windowForPdf) {

              // Use the already-opened window — browser allows this
              const url = CasedeskUrl.getAttachment(financialStatementData?.pdfUrl);
              windowForPdf.location.href = url;

              return this.setState({
                isSaving: false
              });
              
            } else {
              return this.redirect(`/app/email/send/statement/${financialStatementData?.financialStatement?.id ? financialStatementData?.financialStatement?.id : financialStatementData?.id}`);
            }
          })
        },
        onError: err => {
          this.setState({
            isSaving: false
          });

          if (err?.errorId === "statement_data_outdated") {
            this.initializePage(financialStatement?.id);
            this.setState({
              isStatementOutdatedPopupOpen: true
            })
          }
        }
      });
    });
  }

  public startSendingProcess = () => {
    return this.changeStatementStatusToDefinitive(false);
  }

  public startPrintingProcess = () => {
    return this.changeStatementStatusToDefinitive(true);
  }

  public changeChargeSentStatus = (ownerStatement, callback?) => {
    const isSent = ownerStatement?.isSent;

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_START,
        payload: {
          statementId: ownerStatement?.id,
          isSent: !isSent
        },
        onSuccess: (updatedStatement) => {
          // Update the statement on financialStatements array
          const updatedStatements = this.state?.financialStatements.map(statement => {
            if (statement.id === updatedStatement.id) {
              return updatedStatement
            } else {
              return statement
            }
          });

          this.setState({
            isSaving: false,
            financialStatements: updatedStatements
          }, () => {
            if (typeof callback === "function") {
              callback();
            }
          })
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public changeReadinessStatus = (data) => {
    const readinessStatusIdToSet = data?.readinessStatusId ===
      ReadinessStatusContainer.pickIdFromLabel("NotReady") ?
      ReadinessStatusContainer.pickIdFromLabel("ReadyForReview") :
      ReadinessStatusContainer.pickIdFromLabel("NotReady");

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_START,
        payload: {
          statementId: data?.id,
          readinessStatusId: readinessStatusIdToSet
        },
        onSuccess: (financialStatement) => {
          // Update the statement on financialStatements array
          const updatedStatements = this.state?.financialStatements.map(statement => {
            if (statement.id === financialStatement.id) {
              return financialStatement
            } else {
              return statement
            }
          });

          this.setState({
            isSaving: false,
            financialStatements: updatedStatements
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public changeWithdrawalAmount = (amountWithdrawal: number) => {
    this.setState({
      amountWithdrawal,
    })
  }

  public renderStatementButton = (isConcept: boolean, financialStatement, isAgencyStatement: boolean) => {
    return (
      <div
        className="button-container"
        style={{
          padding: "10px 10px 0 0",
          display: "flex",
          justifyContent: isConcept ? "flex-end" : "space-between",
          width: "100%"
        }}
      >
        {
          !isConcept &&
          <Button
            variant="contained"
            color="primary"
            disabled={this.state.isFetchingStatement}
            onClick={(e) => {
              e.stopPropagation();
              this.redirect(`/app/email/send/statement/${financialStatement?.id}`);
            }}
          >
            {this.trans("button-send-pdf")}
          </Button>
        }
        {
          isConcept &&
          <div>
            {`${this.trans("button-preview-pdf")}   `}
            <ButtonGroup className="statement-button-wrapper" variant="contained" color="primary" style={{ marginLeft: "2px" }}>
              <Button
                variant="outlined"
                color="primary"
                disabled={this.state.isFetchingStatement}
                // TODO fix hardcoded value
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ previewTypeOfPdf: true, languageForPdf: 1 }, this.download.bind(this, financialStatement?.data?.payoutSection?.actualPayoutCharge?.id));
                }}
              >
                {"EN"}
              </Button>
              <Button
                variant="outlined"
                color="primary"
                disabled={this.state.isFetchingStatement}
                // TODO fix hardcoded value
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ previewTypeOfPdf: true, languageForPdf: 2 }, this.download.bind(this, financialStatement?.data?.payoutSection?.actualPayoutCharge?.id));
                }}
              >
                {"NL"}
              </Button>
            </ButtonGroup>
          </div>
        }
        {
          !isConcept &&
          <div>
            {`${this.trans("button-print-pdf")}   `}

            <ButtonGroup className="statement-button-wrapper" variant="contained" color="primary" style={{ marginLeft: "2px" }}>
              <Button
                variant="outlined"
                color="primary"
                disabled={this.state.isFetchingStatement}
                // TODO fix hardcoded value
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ languageForPdf: 1 }, this.download.bind(this, financialStatement?.data?.payoutSection?.actualPayoutCharge?.id));
                }}
              >
                {"EN"}
              </Button>
              <Button
                variant="outlined"
                color="primary"
                disabled={this.state.isFetchingStatement}
                // TODO fix hardcoded value
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ languageForPdf: 2 }, this.download.bind(this, financialStatement?.data?.payoutSection?.actualPayoutCharge?.id));
                }}
              >
                {"NL"}
              </Button>
            </ButtonGroup>
          </div>
        }
        {
          isConcept && !isAgencyStatement &&
          <Button
            variant="contained"
            color="primary"
            disabled={this.state.isFetchingStatement}
            onClick={(e) => {
              e.stopPropagation();
              if (this.props?.app?.settings?.agency?.isActivateInvoiceNumber) {
                this.setState({ isCreateInvoicePopupOpen: true });
              } else {
                this.setState({ isActivateInvoicingPopupOpen: true });
              }
            }}
            style={{ marginLeft: "15px" }}
          >
            {this.trans("button-create-invoice")}
          </Button>
        }
        {
          isAgencyStatement &&
          <Button
            variant="contained"
            color="primary"
            disabled={this.state.isFetchingStatement}
            onClick={(e) => {
              e.stopPropagation();
              this.setState({ 
                openSavingsDialog: true, 
                amountWithdrawal: this.formatter.simpleFormatNumber(this.state.financialStatements[0]?.data?.payoutSection?.result - this.state.financialStatements[0]?.data?.payoutSection?.withdrawnAmount),
              });
            }}
            style={{ marginLeft: "15px" }}
          >
            {this.trans("button-withdrawal-agency-statement")}
          </Button>
        }
      </div>
    );
  }

  public handleChangeExpansionPanel = panel => (event, expanded) => {
    event
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  public render() {
    const companyId: number = this.state.financialStatements.length > 0 &&
      this.state.financialStatements?.[0]?.ownerId;
    const companyEntity: CompanyInterface = this.props.app.companies
      .find((company: CompanyInterface) => company.id === companyId);
    const agency: CompanyInterface = this.getAgency();
    const agencyLogo = this.getAgency().attachments?.find(attachment => attachment?.isAvatar) ? CasedeskUrl.getAttachment(this.getAgency().attachments?.find(attachment => attachment?.isAvatar)?.cropImgPath) : null;
    const isFirstOwnerAddressLineShown = companyEntity?.address?.route || companyEntity?.address?.fullAddress?.streetNumber;
    const isSecondOwnerAddressLineShown = companyEntity?.address?.postalCode || companyEntity?.address?.locality;
    const defaultBankAccountId = (this.getAgency().bankAccounts.filter((account) => account.isDefault)[0] && this.getAgency().bankAccounts.filter((account) => account.isDefault)[0].accountId) || this.getAgency().mainBankAccountId;

    return (
      <div className="state-app">
        <div className="box box-full full-width has-details-page-header">
          <div className="component-header has-back-button two-row-title">
            <div className="inner-wrapper" style={{ width: "100%" }}>
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <div className="title-wrapper" style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", width: "100%" }}>
                <h1>
                  {this.state.financialStatements.length > 0 && `${this.formatter.monthYearFormatDate(this.state.financialStatements?.[0]?.firstDate)}`}
                </h1>
              </div>
            </div>
          </div>
          <div className="component-wrapper no-margin-top">
            <div className="component">
              {this.state?.financialStatements.length > 0 &&
                this.state?.financialStatements?.map((financialStatement, index) => {
                  const statusStatementConcept = index !== this.state.financialStatements.length - 1 ?
                    false :
                    financialStatement?.statusId !== FinancialStatementStatusContainer.pickIdFromLabel("DEFINITIVE");

                  return (
                    <ExpansionPanel
                      className="expansion-panel" 
                      expanded={this.state.expanded === index}
                      onChange={this.handleChangeExpansionPanel(index)}
                    >
                      <ExpansionPanelSummary>
                        <div className="expansion-panel-wrapper" style={{ width: "100%" }}>
                          <h2 style={{ margin: "0", fontWeight: "normal", display: "flex", alignItems: "center" }}>{`${this.trans("owner-statement")} ${this.state?.financialStatements.length <= 1 ? "" : index + 1}`}
                            {!this.state?.isAgencyStatement && (
                              <span style={{ marginLeft: "20px" }}>
                                {
                                  index !== this.state?.financialStatements.length - 1 && (
                                    <span>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={financialStatement?.isSent}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              this.changeChargeSentStatus(financialStatement);
                                            }}
                                            color="primary"
                                          // disabled={true}
                                          />
                                        }
                                        label={this.trans("status-sent")}
                                      />
                                    </span>
                                  )}

                                {
                                  index === this.state?.financialStatements.length - 1 &&
                                  <span>
                                    {
                                      financialStatement?.statusId === FinancialStatementStatusContainer.pickIdFromLabel("DEFINITIVE") && (
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              checked={financialStatement?.isSent}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                this.changeChargeSentStatus(financialStatement);
                                              }}
                                              color="primary"
                                            />
                                          }
                                          label={this.trans("status-sent")}
                                        />
                                      )
                                    }
                                    {
                                      (financialStatement?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("NotReady") ||
                                        financialStatement?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("ReadyForReview")) && this.props.app?.settings?.agency?.reviewOwnerStatements && (
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              checked={financialStatement?.readinessStatusId === ReadinessStatusContainer.pickIdFromLabel("ReadyForReview")}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                this.changeReadinessStatus(financialStatement);
                                              }}
                                              color="primary"
                                            />
                                          }
                                          label={this.trans("statement-status/ready-for-review")}
                                        />
                                      )
                                    }
                                  </span>
                                }
                              </span>)}

                          </h2>
                          {this.renderStatementButton(statusStatementConcept, financialStatement, this.state?.isAgencyStatement)}
                        </div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails className="expansion-panel-details">
                        <Card className="card balance-card" style={{ position: "relative" as "relative", minHeight: "400px", width: "100%" }}>
                          {
                            this.state.isFetchingStatement && (
                              <div className="component-spinner-wrapper">
                                <CircularProgress />
                              </div>
                            )
                          }
                          {financialStatement && (
                            <div>
                              <div className="table-container">
                                {financialStatement && Object.keys((financialStatement || {})).length > 0 && (
                                  <React.Fragment>
                                    <div style={{ padding: "20px" }}>
                                      <div style={{ display: "inline-block", padding: "0px" }}>
                                        {
                                          agencyLogo && (
                                            <div style={{ width: "160px" }}>
                                              <img src={agencyLogo} alt="agency-logo" style={{ display: "block", width: "100%", height: "auto", padding: "0px 0px 20px 0px" }} />
                                            </div>
                                          )
                                        }

                                        {
                                          !agencyLogo && (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                              <div className="container_logo">
                                                <div className="container_watermark">
                                                  {this.trans("your-logo-here")}
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        }

                                        <div style={{ padding: "5px 20px 0px 0px" }}>
                                          <div style={{ fontSize: "15px", fontWeight: "bold", marginBottom: "5px" }}>{companyEntity?.name}</div>
                                          {
                                            isFirstOwnerAddressLineShown && (
                                              <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "2px" }}>{companyEntity?.address?.route || ""} {companyEntity?.address?.fullAddress?.streetNumber || ""}</div>
                                            )
                                          }

                                          {
                                            isSecondOwnerAddressLineShown && (
                                              <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "2px" }}>{companyEntity?.address?.postalCode || ""} {companyEntity?.address?.locality || ""}</div>
                                            )
                                          }
                                        </div>
                                      </div>
                                      <div style={{ display: "inline-block", padding: "0px 20px 0px 0px", float: "right" }}>
                                        <div style={{ padding: "0px", marginBottom: "5px" }}>
                                          <div style={{ fontSize: "17px", fontWeight: "bold" }}>{agency?.name}</div>
                                        </div>
                                        <div>
                                          {
                                            agency?.phone && <div style={{ marginBottom: "2px" }}>{this.trans("phone")}: {agency?.phone}</div>
                                          }
                                          {
                                            agency?.website && <div style={{ marginBottom: "2px" }}>{this.trans("website")}: {agency?.website}</div>
                                          }
                                          {
                                            defaultBankAccountId && <div style={{ marginBottom: "2px" }}>{this.trans("iban")}: {defaultBankAccountId}</div>
                                          }
                                          {
                                            agency?.mainBankAccountName && <div style={{ marginBottom: "2px" }}>{this.trans("list-label-bank-account-name")}: {agency?.mainBankAccountName}</div>
                                          }
                                          {
                                            agency?.bic && <div style={{ marginBottom: "2px" }}>{this.trans("label-bic")}: {agency?.bic}</div>
                                          }
                                          {
                                            agency?.companyRegistry && <div style={{ marginBottom: "2px" }}>{this.trans("label-kvk")}: {agency?.companyRegistry}</div>
                                          }
                                          {
                                            agency?.vat && <div style={{ marginBottom: "2px" }}>{this.trans("label-vat")}: {agency?.vat}</div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    <StatementDataRenderer
                                      {...this.props}
                                      statementData={financialStatement}
                                      isAgencyStatement={this.state.isAgencyStatement}
                                      companyEntity={companyEntity}
                                      fetchStatement={() => this.initializePage(financialStatement?.id)}
                                    />
                                  </React.Fragment>
                                )}
                              </div>
                            </div>
                          )}
                        </Card>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  );
                })
              }
            </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isCreateInvoicePopupOpen}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.trans("preprocess/lockstatement-info/beforesend")}
          positiveButtonLabel={this.trans("button-view")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.setState({ isCreateInvoicePopupOpen: false }, this.startPrintingProcess)}
          onDiscard={() => this.setState({ isCreateInvoicePopupOpen: false })}
          additionalBtns={(
            [
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.setState({ isCreateInvoicePopupOpen: false }, this.startSendingProcess)
                }
                }
              >
                {this.trans("dialog-button/send")}
              </Button>
            ]
          )}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isActivateInvoicingPopupOpen}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.trans("preprocess/lockstatement-info/needactivateinvoicing")}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("dialog-button/close")}
          onSave={() => this.setState({ isActivateInvoicingPopupOpen: false })}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isStatementOutdatedPopupOpen}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.trans("preprocess/lockstatement-error/statementoutdated-info/needactivateinvoicing")}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("dialog-button/close")}
          onSave={() => this.setState({ isStatementOutdatedPopupOpen: false })}
        />

        <SavingsCompanyDialog
          {...this.props}
          entity={this.state.entity}
          financialStatement={this.state.financialStatements[0]}
          isOpen={this.state.openSavingsDialog}
          savingsType={this.state.savingsType}
          initializePage={this.initializePage}
          amountWithdrawal={this.state.amountWithdrawal}
          closeDialog={() => this.setState({ openSavingsDialog: false })}
          changeWithdrawalAmount={this.changeWithdrawalAmount}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    units: state.units,
    globalTypes: state.globalTypes,
    financialStatements: state.financialStatements,
  };
};

export default connect(mapStateToProps)(
  FinancialStatementUpdate
);
